/** Read both generations of sale operations without changing the stored listing. */
export const saleOperationValues = value => {
  if (Array.isArray(value)) return value;
  if (value === 'busqueda-inversor') {
    return ['inversor-minoritario', 'inversor-mayoritario'];
  }
  // Preserve unknown strings for the existing validators to reject them.
  return typeof value === 'string' && value ? [value] : [];
};

/** Only adapt sale data; purchase mandates have their own field and semantics. */
export const saleDataForDisplay = data =>
  data?.listingType === 'free-listing' && typeof data.tipo_operacion === 'string'
    ? { ...data, tipo_operacion: saleOperationValues(data.tipo_operacion) }
    : data;
